<template>
  <b-navbar class="local-lm-top-navbar">
    <template slot="brand">
      <b-navbar-item
        tag="router-link"
        :to="{ name: 'Orders' }"
        v-t="$t('Common.titleProject')"
        class="local-lm-brand"
      />
      <div class="local-lm-top--version">
        <span>{{ appVersion }}</span>
      </div>
    </template>
    <template slot="end">
      <div class="local-lm-options">
        <b-navbar-item>
          <b-menu-list>
            <b-menu>
              <b-menu-item
                icon="account-outline"
                :label="userName"
                class="lm-default-btn-topmenu"
              />
            </b-menu>
          </b-menu-list>
        </b-navbar-item>
        <b-navbar-item>
          <b-menu-list>
            <b-menu>
              <b-menu-item
                icon="exit-to-app"
                :label="$t('Common.logout')"
                class="lm-default-btn-topmenu"
                @click.prevent="logout"
              />
            </b-menu>
          </b-menu-list>
        </b-navbar-item>
      </div>
    </template>
  </b-navbar>
</template>

<script>
import { services } from '@/services'

export default {
  name: 'TopMenu',
  computed: {
    userName () {
      return this.$store.getters['user/getUserName']
    }
  },
  data () {
    return {
      appVersion: (process.env.VUE_APP_ENV_VERSION !== 'undefined') ? process.env.VUE_APP_ENV_VERSION : ''
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('loading/start')

      this.$store.dispatch('orders/flush')
      this.$store.dispatch('filters/flush')
      this.$store.dispatch('modal/flush')
      this.$store.dispatch('user/flush')
      this.$store.dispatch('messages/flush')
      this.$store.dispatch('modal/disable')
      this.$store.dispatch('messages/disable')

      const data = this.$store.getters['user/status']
      const service = services.userService(data)
      service.logout()

      this.$store.dispatch('loading/stop')
      this.$router.push('Login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/TopMenu.vue